import { apiService } from './api';
import { PaginationParams } from '../types';

export interface CustomerDTO {
  id: number;
  code: string;
  name: string;
  contactEmail: string;
  contactPhone?: string;
  billingAddress?: string;
  shippingAddress?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  taxId?: string;
  creditLimit?: number;
  paymentTerms?: string;
  customerType?: string;
  isActive: boolean;
  isDefault: boolean;
  createdAt: string;
}

export interface CreateCustomerRequest {
  code: string;
  name: string;
  contactEmail: string;
  contactPhone?: string;
  billingAddress?: string;
  shippingAddress?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  taxId?: string;
  creditLimit?: number;
  paymentTerms?: string;
  customerType?: string;
}

export interface UpdateCustomerRequest extends CreateCustomerRequest {
  isActive: boolean;
}

const CUSTOMERS_API = '/customers';

export const customerService = {
  getCustomers: (params: PaginationParams) =>
    apiService.get<CustomerDTO[]>(CUSTOMERS_API, {
      pageNumber: params.pageNumber || 1,
      pageSize: params.pageSize || 50,
    }),

  getCustomerById: (id: string | number) =>
    apiService.get<CustomerDTO>(`${CUSTOMERS_API}/${id}`),

  getCustomerByCode: (code: string) =>
    apiService.get<CustomerDTO>(`${CUSTOMERS_API}/code/${code}`),

  checkCustomerCodeExists: async (code: string) => {
    try {
      await apiService.get<CustomerDTO>(`${CUSTOMERS_API}/code/${code}`);
      return { data: { data: { exists: true } } };
    } catch {
      return { data: { data: { exists: false } } };
    }
  },

  createCustomer: (data: CreateCustomerRequest) =>
    apiService.post<CustomerDTO>(CUSTOMERS_API, data),

  updateCustomer: (id: string | number, data: UpdateCustomerRequest) =>
    apiService.put<CustomerDTO>(`${CUSTOMERS_API}/${id}`, data),

  deleteCustomer: (id: string | number) =>
    apiService.delete<void>(`${CUSTOMERS_API}/${id}`),
};
